
import * as React from 'react'; 
import { Logo } from '../Logo/Logo';
import { Navigation } from '../Navigation/Navigation';

export const Navbar: React.FC<Props> = (props) =>
<header className = "navmain">
    <div className = "navbar__left">
        <Logo isSmallOnMobile = {true} />
    </div>
    <div className = "navbar__center">
         <Navigation ismobile={false}/>   
    </div>

    <div className = "navbar__right">
        <div className = "navbar__menu-button" onClick = {props.onMobileMenuClick}>
        <i className="fa-solid fa-bars"></i>
        </div> 
    </div>
</header>

interface Props { 
    onUserMenuClick: () => void;
    onMobileMenuClick: () => void;
}